"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IconContainer_1 = __importStar(require("../IconContainer"));
const MoneyIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsx)(IconContainer_1.StyledSvg, { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: (0, jsx_runtime_1.jsx)("path", { d: "M11.233 10.025c-1.107-.35-1.497-.863-1.497-1.538V8.45c0-1.725 2.629-1.45 3.547-1.15.918.237 1.824.687 2.692 1.275l1.459-2.525a9.054 9.054 0 00-4.05-1.6V2h-2.252v2.412C8.39 4.687 6.566 6.25 6.566 8.65v.037c0 2.55 1.547 3.738 4.68 4.588 1.798.412 3.61.688 3.584 2.112v.05c0 1.738-2.717 1.488-3.585 1.275-1.283-.262-2.364-.862-3.547-1.75L6 17.425c1.434 1.075 3.258 1.813 5.132 2.05V22h2.264v-2.488c2.767-.3 4.604-1.862 4.604-4.25v-.05c.013-4.124-4.315-4.412-6.767-5.187z" }) }));
exports.default = (0, IconContainer_1.default)(MoneyIcon);
//# sourceMappingURL=index.js.map